import React, { useState } from "react";

import { useStateContext } from "../contexts/ContextProvider";
import Button from "./Button";
import ExpensesCard from "./ExpensesCard";
import AddExpenseModal from "./AddExpenseModal";
import NavigateBack from "./NavigateBack";

const ManageExpensesModal = (props) => {
  const { currentProperty } = props;
  const { expenses, modal, handleModal } = useStateContext();
  const [currentExpenseId, setCurrentExpenseId] = useState(null);

  const currentPropertyExpenses = expenses.filter(
    (x) => x.propertyId === currentProperty.id
  );

  const currentExpense = currentPropertyExpenses.find(
    (x) => x.id === currentExpenseId
  );

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      <NavigateBack
        zIndex="z-10"
        returnText="Back to property"
        modalNavigation={() => {
          handleModal("manageExpenses");
        }}
      />
      {modal.addExpense && (
        <AddExpenseModal currentProperty={currentProperty} />
      )}
      {/* {modal.editExpense && (
        <EditExpenseModal
          expenseId={currentExpenseId}
          currentExpense={currentExpense}
        />
      )} */}
      <div className="flex justify-center text-xl mt-14">Manage Expenses</div>
      <div
        className="flex justify-center text-blue-500 hover:text-blue-700 cursor-pointer mt-5"
        onClick={() => handleModal("addExpense")}
      >
        + Add Expense
      </div>
      <ExpensesCard
        expenses={currentPropertyExpenses}
        setCurrentExpenseId={setCurrentExpenseId}
      />
      {/* <div className="flex justify-center w-full mt-10 mb-40">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("manageExpenses")}
        />
      </div> */}
    </div>
  );
};

export default ManageExpensesModal;
